import { render, staticRenderFns } from "./Comic.vue?vue&type=template&id=6b2e96eb&scoped=true&"
import script from "./Comic.vue?vue&type=script&lang=js&"
export * from "./Comic.vue?vue&type=script&lang=js&"
import style0 from "./Comic.vue?vue&type=style&index=0&id=6b2e96eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e96eb",
  null
  
)

export default component.exports